import React from 'react';
import { Skeleton } from './Skeleton';

interface MatchCardSkeletonProps {
  count?: number;
}

export const MatchCardSkeleton: React.FC<MatchCardSkeletonProps> = ({ count = 3 }) => {
  return (
    <ul className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <li
          key={index}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-solana-900/30 p-5 shadow-[0_0_35px_rgba(16,21,36,0.45)] backdrop-blur"
        >
          <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="space-y-3 flex-1">
              <div className="flex flex-wrap items-center gap-3">
                <Skeleton variant="text" className="h-5 w-24" />
                <Skeleton variant="rectangular" className="h-6 w-20 rounded-full" />
              </div>
              <Skeleton variant="text" className="h-3 w-32" />
              <Skeleton variant="text" className="h-3 w-28" />
              <Skeleton variant="text" className="h-3 w-36" />
            </div>
            <Skeleton variant="rectangular" className="h-10 w-28 rounded-full" />
          </div>
        </li>
      ))}
    </ul>
  );
};
